export default "__VITE_ASSET__mdI1miHq__"